import "core-js/modules/web.dom.iterable";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function filterProductNodes(currentNode) {
  const objToKeep = ['images', 'generated_tcvars', 'prices', 'quantity_lot', 'reference', 'reference_encoded', 'translations'];
  let obj = false;

  if (objToKeep.indexOf(currentNode[0]) !== -1) {
    obj = true;
  }

  return obj;
}

function fetchProducts(_x, _x2) {
  return _fetchProducts.apply(this, arguments);
}

function _fetchProducts() {
  _fetchProducts = _asyncToGenerator(function* (context, payload) {
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(context.getters['i18n/locale'].market, "/").concat(context.getters['i18n/locale'].language, "/layer-products/").concat(payload);
    const {
      data
    } = yield context.$axios.get(xhrUri);
    const cNode = {};
    const newData = Object.entries(data).reduce((prev, cur) => {
      const curVal = Object.entries(cur[1]).filter(filterProductNodes).reduce((obj, item) => {
        const newObj = obj; // eslint-disable-next-line

        newObj[item[0]] = item[1];
        return newObj;
      }, {}); // eslint-disable-next-line

      cNode[cur[0]] = curVal;
      return cNode;
    }, {});
    return newData;
  });
  return _fetchProducts.apply(this, arguments);
}

export { fetchProducts as default };